

























import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import { Dictionary } from "@/lib/Dictionary.type";
import dataStore from "@/store";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import { Resource } from "@/modules/account/resource";
import ErrorConverterService from "@/modules/forms/error-converter.service";
import PlushieStore from "@/modules/plushie/store";

import ProductGroupForm from "./Form.vue";

import FactoryRushCapacityStore from "../../store";

@Component({
  metaInfo: {
    title: "Add Rush Product Group",
  },
  components: {
    FormErrors,
    LoadingSpinner,
    ProductGroupForm,
  },
})
export default class FactoryRushCapacityProductGroupAddPage extends Vue {
  @Prop({ default: () => ({}) })
  public readonly query!: Dictionary<unknown>;

  @Prop({ default: () => ({}) })
  public readonly listQuery?: Dictionary<string[]>;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  @Inject("ErrorConverterService")
  private fErrorConverterService!: ErrorConverterService;

  private fErrorsList: string[] = [];
  private fFactoryRushCapacityStore: FactoryRushCapacityStore;
  private fIsLoading = false;
  private fPlushieStore: PlushieStore;

  get canManageProductGroups(): boolean {
    const user = this.fUserProvider.getUser();

    return (
      user !== undefined &&
      user.hasPermissionForResource(Resource.FACTORY_RUSH_CAPACITY_MANAGE)
    );
  }

  get errorsList(): string[] {
    return this.fErrorsList;
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  constructor() {
    super();

    this.fFactoryRushCapacityStore = getModule(
      FactoryRushCapacityStore,
      dataStore
    );
    this.fPlushieStore = getModule(PlushieStore, dataStore);
  }

  public onCancel(): void {
    this.openList();
  }

  public onSaved(): void {
    this.openList();
  }

  protected async created(): Promise<void> {
    if (!this.canManageProductGroups) {
      return;
    }

    this.fErrorsList = [];
    this.fIsLoading = true;

    try {
      await Promise.all([
        this.fFactoryRushCapacityStore.loadFactoryRushCapacityProductGroups({
          useCache: false,
        }),
        this.fFactoryRushCapacityStore.loadFactoryRushCapacityProductGroupMembers(
          { useCache: false }
        ),
        this.fPlushieStore.loadProducts(),
      ]);
    } catch (error) {
      this.fErrorsList = this.fErrorConverterService.describeError(error);
    } finally {
      this.fIsLoading = false;
    }
  }

  private openList(): void {
    void this.$router.push({
      name: "FactoryRushCapacityProductGroupsListPage",
      query: this.listQuery,
    });
  }
}
